import VISA_LOGO from "../../../../assets/images/visa_logo_official.svg";
import MASTERCARD_LOGO from "../../../../assets/images/mastercard_logo_unofficial.svg";

export const CARD_LOGOS = {
  Mastercard: MASTERCARD_LOGO,
  Visa: VISA_LOGO,
} as const;

export const LOGO_SIZE_CONFIG = {
  "x-small": {
    mastercard: { bottom: "5px", right: "0px" },
    visa: { bottom: "7.53px", right: "8px" },
    logoSize: "20px",
  },
  small: {
    mastercard: { bottom: "7px", right: "0px" },
    visa: { bottom: "11.65px", right: "12px" },
    logoSize: "32px",
  },
  large: {
    mastercard: { bottom: "8px", right: "0px" },
    visa: { bottom: "18.01px", right: "20px" },
    logoSize: "68px",
  },
} as const;

export const CARD_ASPECT_RATIOS = {
  Mastercard: 152 / 108,
  Visa: 1920 / 620,
} as const;
